<form [formGroup]="form">
  <ng-template #recursiveListGroup let-detailGroupInfoList let-formGroup="formGroup">
    <ng-container *ngIf="detailGroupInfoList.length">
    </ng-container>
    <div *ngFor="let detailGroupInfo of detailGroupInfoList;let i = index">
      <!-- Conditional Form Groups: collapse a group card entirely when every field in it is
           hidden by the active variant — avoids rendering empty cards on assessment-style
           forms where most groups belong to a single variant. -->
      <div class="card" *ngIf="detailGroupInfo.detailInfos.length && detailGroupInfo.hasAnyVisibleField">
        <strong class="pt-3 ps-3" *ngIf="detailGroupInfo.title">{{detailGroupInfo.title}}</strong>
        <div class="ps-3 pt-1" style="white-space: pre-line" *ngIf="detailGroupInfo.description">
          {{detailGroupInfo.description}}
        </div>
        <div class="card-body">
          <ng-container
            *ngTemplateOutlet="recursiveListQuestion; context:{ $implicit: detailGroupInfo.detailInfos, formGroup: form.controls[detailGroupInfo.uuid] }">
          </ng-container>
        </div>
      </div>
    </div>

  </ng-template>

  <ng-template #recursiveListQuestion let-detailInfoList let-formGroup="formGroup">
    <app-detail-info-list [detailInfoList]="detailInfoList" [formGroup]="formGroup">
    </app-detail-info-list>
  </ng-template>

  <ng-container *ngTemplateOutlet="recursiveListGroup; context:{ $implicit: detailGroupInfoList }">
  </ng-container>
</form>